import { getAccessToken } from '../component-utils';

export type BureauReportDownloadKind = 'creditorwatch' | 'equifax-consumer' | 'equifax-fraud-check';

const DOWNLOAD_PATH: Record<BureauReportDownloadKind, string> = {
  creditorwatch: '/credit/download-creditorwatch-report',
  'equifax-consumer': '/credit/download-equifax-consumer-report',
  'equifax-fraud-check': '/credit/download-equifax-fraud-check-report',
};

export const bureauReportDownloadTarget = (
  type: string | undefined,
  id: string | number | undefined,
  pdfRequestId?: string,
): { kind: BureauReportDownloadKind; resourceId: string } | null => {
  if (type === 'CreditorWatch' && pdfRequestId) {
    return { kind: 'creditorwatch', resourceId: pdfRequestId };
  }
  if ((type === 'EquifaxConsumer' || type === 'EquifaxFraudCheck') && id != null && `${id}`.length > 0) {
    return {
      kind: type === 'EquifaxConsumer' ? 'equifax-consumer' : 'equifax-fraud-check',
      resourceId: String(id),
    };
  }
  return null;
};

/**
 * Mint a short-lived signed URL with the logged-in user's JWT, then open it.
 * window.open cannot send the Authorization header.
 */
export const openAuthorizedBureauReport = async (
  apiUrl: string,
  kind: BureauReportDownloadKind,
  resourceId: string,
): Promise<void> => {
  const accessToken = getAccessToken();
  const mintUrl = `${apiUrl}/credit/bureau-report-download-link/${kind}/${encodeURIComponent(resourceId)}`;
  const response = await fetch(mintUrl, {
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
  });
  if (!response.ok) {
    throw new Error('Unable to download report');
  }
  const body = await response.json();
  const token = body?.payload?.token;
  if (typeof token !== 'string' || !token) {
    throw new Error('Unable to download report');
  }
  const url = `${apiUrl}${DOWNLOAD_PATH[kind]}/${encodeURIComponent(resourceId)}?token=${encodeURIComponent(token)}`;
  window.open(url);
};
